import { useState, useContext, useEffect, useRef } from "react";

import SuiBox from "components/SuiBox";
import SuiButton from "components/SuiButton";

import SuiTypography from "components/SuiTypography";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";

import { dataURLtoFile, getImageDimensions } from "utils/imageHelper";

import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";

import FullscreenIcon from "@mui/icons-material/Fullscreen";
import DownloadIcon from "@mui/icons-material/Download";
import DeleteIcon from "@mui/icons-material/Delete";

import { saveAs } from "file-saver";
import Prompt from "components/UpStyled/Prompt";
import FavoriteBorderRoundedIcon from "@mui/icons-material/FavoriteBorderRounded";
import FavoriteRoundedIcon from "@mui/icons-material/FavoriteRounded";
import { Empty } from "antd";

import Lightbox from "yet-another-react-lightbox";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import Download from "yet-another-react-lightbox/plugins/download";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";

const FavoriteView = ({
  selectedResult,
  setViewType,
  sketchData,
  handleSetWorkingImage,
  extra,
  handleToggleFavorite,
  canDelete = true,
}) => {
  const [imgsViewerVisible, setImgsViewerVisible] = useState(false);
  const [imgsViewerCurrent, setImgsViewerCurrent] = useState(0);

  let images = selectedResult?.images || [];
  if (extra?.favorite_list) {
    images = extra?.favorite_list;
  }

  const openImgsViewer = () => setImgsViewerVisible(true);
  const closeImgsViewer = () => setImgsViewerVisible(false);
  const imgsViewerNext = () => setImgsViewerCurrent(imgsViewerCurrent + 1);
  const imgsViewerPrev = () => setImgsViewerCurrent(imgsViewerCurrent - 1);

  const handleFullScreen = (e, index) => {
    setImgsViewerCurrent(index);
    openImgsViewer();
  };

  const handleDownload = (e, url) => {
    saveAs(url);
  };

  const handleClickFavorite = async (url, findIndex) => {
    const { width, height } = await getImageDimensions(url);
    const data = {
      ...sketchData,
      width,
      height,
      imgurl: url,
    };
    handleToggleFavorite(data, findIndex);
  };

  const favorite_list = extra?.favorite_list || [];

  return (
    <div style={{ maxHeight: 600, overflow: "auto" }}>
      <Lightbox
        open={imgsViewerVisible}
        close={closeImgsViewer}
        slides={images.map((x, index) => ({ src: x?.url || x?.imgurl, id: index }))}
        plugins={[Zoom, Download, Thumbnails]}
        zoom={{ maxZoomPixelRatio: 3 }}
        index={imgsViewerCurrent}
      />

      <SuiBox my={1}>
        <ResponsiveMasonry columnsCountBreakPoints={{ 250: 1, 650: 2, 900: 2, 1300: 3, 1600: 4 }}>
          <Masonry>
            {images.map((x, index) => {
              const url = x?.url || x?.imgurl;
              const findIndex = favorite_list.findIndex(
                (item) => item.imgurl == url || item?.url == url
              );

              return (
                <SuiBox sx={{ mb: 1, mx: 1 }}>
                  <div className="hover-parent" style={{ position: "relative" }}>
                    <img
                      src={x?.url || x?.imgurl}
                      alt={"image_" + index}
                      style={{ width: "100%", height: "auto", cursor: "pointer" }}
                      onClick={(e) => handleFullScreen(e, index)}
                    />

                    <SuiBox
                      className="hover-children"
                      sx={{ position: "absolute", top: 4, right: 4 }}
                    >
                      <SuiBox display="flex" alignItems="center" justifyContent="flex-end" gap={1}>
                        <Tooltip title={"Fullscreen"}>
                          <IconButton
                            size="small"
                            color="dark"
                            sx={{
                              backgroundColor: "#ffffff",
                              "&:hover": {
                                backgroundColor: "#e3e3e3",
                              },
                            }}
                            onClick={(e) => handleFullScreen(e, index)}
                          >
                            <FullscreenIcon />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title={"Download"}>
                          <IconButton
                            size="small"
                            color="dark"
                            sx={{
                              backgroundColor: "#ffffff",
                              "&:hover": {
                                backgroundColor: "#e3e3e3",
                              },
                            }}
                            onClick={(e) => handleDownload(e, url)}
                          >
                            <DownloadIcon />
                          </IconButton>
                        </Tooltip>
                        {findIndex == -1 ? (
                          <Tooltip title={"Add Favorite"}>
                            <IconButton
                              size="small"
                              color="dark"
                              sx={{
                                backgroundColor: "#ffffff",
                                "&:hover": {
                                  backgroundColor: "#e3e3e3",
                                },
                              }}
                              onClick={(e) => handleClickFavorite(url, findIndex)}
                            >
                              <FavoriteBorderRoundedIcon />
                            </IconButton>
                          </Tooltip>
                        ) : (
                          <Tooltip title={"Remove Favorite"}>
                            <IconButton
                              size="small"
                              color="error"
                              sx={{
                                backgroundColor: "#ffffff",
                                "&:hover": {
                                  backgroundColor: "#e3e3e3",
                                },
                              }}
                              onClick={(e) => handleClickFavorite(url, findIndex)}
                            >
                              <FavoriteRoundedIcon />
                            </IconButton>
                          </Tooltip>
                        )}
                      </SuiBox>
                    </SuiBox>

                    <div
                      className="overlay"
                      style={{
                        textAlign: "center",
                        width: "100%",
                        zIndex: 2,
                      }}
                    >
                      <SuiButton
                        variant="contained"
                        color="white"
                        size="small"
                        sx={{
                          whiteSpace: "nowrap",
                          textTransform: "capitalize",
                          width: "100%",
                          mb: 1,
                        }}
                        onClick={() => handleSetWorkingImage(url)}
                      >
                        Set as Working Image
                      </SuiButton>
                    </div>
                  </div>
                </SuiBox>
              );
            })}
          </Masonry>
        </ResponsiveMasonry>
        {images.length == 0 ? <Empty /> : null}
      </SuiBox>
    </div>
  );
};

export default FavoriteView;
